/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
// import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import moment from 'moment';
import { SearchCriteria } from '../SearchCriteria';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartEmptyState } from '../ChartEmptyState';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        formControl: {
            display: 'flex',
            flexFlow: 'row wrap',
            alignItems: 'center',
            justifyContent: 'center',
        },
        formLabel: {
            marginRight: '10px',
        },
    }),
);

export enum BillingByGroupOptionEnum {
    FEES_BILLED = 0,
    FEES_RECORDED,
    FEES_COLLECTED,
    BILLABLE_HOURS,
    NON_BILLABLE_HOURS,
}

interface BudgetYearChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    // groupBy: 'PersonActing' | 'PersonAssisting' | 'PersonResponsible';
}

interface ChartState {
    options: BillingByGroupOptionEnum;
    totalValueAmount: number;
    groupings: Date[];
    formats: string[];
    valueAmounts: number[];
    staffBudgets: StaffBudget[];
    symbol: string;
}

export const BudgetYearChart: React.FC<BudgetYearChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    const [state, setState] = useState<ChartState>({
        options: BillingByGroupOptionEnum.FEES_BILLED,
        groupings: [],
        formats: [],
        valueAmounts: [],
        staffBudgets: [],
        totalValueAmount: 0,
        symbol: '$',
    });

    // tslint:disable-next-line:no-any
    const budgetYearQuery = useQuery<BudgetYearData>(BUDGET_YEAR_CHART, {
        variables: {
            // groupBy: props.groupBy,
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
        },
        fetchPolicy: 'cache-and-network',
    });

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    useEffect(() => {
        setState((prevState) => {
            let groupings: Date[] = [];
            let formats: string[] = [];
            let valueAmounts: number[] = [];
            let totalValueAmount: number = 0;
            let _staffBudgets: StaffBudget[] = [];

            if (budgetYearQuery.data && budgetYearQuery.data.statistics && budgetYearQuery.data.statistics.fees && budgetYearQuery.data.statistics.fees.yearBudgets) {
                // tslint:disable-next-line: max-line-length
                const { summaries, staffBudgets } = budgetYearQuery.data.statistics.fees.yearBudgets;

                _staffBudgets = staffBudgets;
                groupings = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.grouping);
                formats = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.format);
                if (state.options === BillingByGroupOptionEnum.FEES_BILLED) {
                    totalValueAmount = summaries.totalFeesBilled;
                    valueAmounts = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.feesBilled);
                } else if (state.options === BillingByGroupOptionEnum.FEES_COLLECTED) {
                    totalValueAmount = summaries.totalFeesCollected;
                    valueAmounts = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.feesCollected);
                } else if (state.options === BillingByGroupOptionEnum.FEES_RECORDED) {
                    totalValueAmount = summaries.totalFeesRecorded;
                    valueAmounts = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.feesRecorded);
                } else if (state.options === BillingByGroupOptionEnum.BILLABLE_HOURS) {
                    totalValueAmount = summaries.totalBillableHours;
                    valueAmounts = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.billableHours);
                } else {
                    totalValueAmount = summaries.totalNonBillableHours;
                    valueAmounts = staffBudgets.map((staffBudget: StaffBudget) => staffBudget.nonBillableHours);
                }
            }

            return {
                ...prevState,
                groupings,
                formats,
                valueAmounts,
                totalValueAmount,
                staffBudgets: _staffBudgets,
            };
        });
        // tslint:disable-next-line: align
    }, [budgetYearQuery.data, budgetYearQuery.loading, budgetYearQuery.error, state.options]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isYearBudgetsChartOpen`);
        }
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            searchCriterias.push({ property: 'FullFinancialYear', operator: '', comparison: '' });

            props.getSelectedItem(searchCriterias, true, `${getBudgetYear(state.groupings)} Budget`, DrillDownType.staffBillingSummary, 'Yearly Budgets');
        }
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        const fieldName = event.target.name;
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                [fieldName]: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };

    const getGroupByTitle = (option: BillingByGroupOptionEnum) => {
        if (option === BillingByGroupOptionEnum.FEES_BILLED) {
            return 'Fees Billed';
        } else if (option === BillingByGroupOptionEnum.FEES_RECORDED) {
            return 'Fees Recorded';
        } else if (option === BillingByGroupOptionEnum.FEES_COLLECTED) {
            return 'Fees Collected';
        } else if (option === BillingByGroupOptionEnum.BILLABLE_HOURS) {
            return 'Billable Hours';
        } else {
            return 'Non-Billable Hours';
        }
    };

    const getBudgetYear = (groupings: Date[]) => {
        
        const startYear = moment(groupings[0]);
        const endYear = moment(groupings[groupings.length - 1]);

        if (startYear.isValid() && endYear.isValid()) {
            return `${startYear.format('YYYY')}/${endYear.format('YY')}`;
        }

        return startYear.isValid() ? startYear.format('YYYY') : endYear.isValid() ? endYear.format('YY') : '';
                
    };

    const getTotal = (total: number) => {
        if (state.options === BillingByGroupOptionEnum.BILLABLE_HOURS || state.options === BillingByGroupOptionEnum.NON_BILLABLE_HOURS) {
            return `${formatNumber(total)}`;
        }
        return `${state.symbol}${formatNumber(total)}`;
    };

    const onPan = (context: { chart: Chart }) => {
        chartRef.current.options.scales.y.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    if (budgetYearQuery.loading) {
        return (
            <ChartSkeleton variant="columns" />
        );
    }

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.valueAmounts) ? ' rv-chart--empty' : ''}`}>
            <IconButtonWrapper aria-label="close">
                <ChartInfo 
                    description={props.description}
                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                    className={`${classes.helpIcon} rv-chart-help`}
                />
                <IconButton aria-label="close" onClick={onCloseChart} size="small">
                    <CloseIcon className={classes.closeIcon} />
                </IconButton>
            </IconButtonWrapper>
            <div className={classes.titleContainer}>
                <ChartHeading icon={<MonetizationOnOutlinedIcon />} title={<>{getBudgetYear(state.groupings)} Budget</>} />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={state.totalValueAmount} format={getTotal} />
                </div>
                <div className={classes.title}>{getGroupByTitle(state.options)}</div>
            </div>
            <div className={classes.barContainer}>
                <Bar
                    ref={chartRef}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            // const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            // const item = state.formats[_index];

                            // const searchCriterias = new Array<SearchCriteria>();
                            // if (state.options === BillingByGroupOptionEnum.FEES_BILLED) {
                            //     searchCriterias.push({ property: 'FullFinancialYear', operator: 'eq', comparison: 'FullearFeesBilled' });
                            // } else if (state.options === BillingByGroupOptionEnum.FEES_COLLECTED) {
                            //     searchCriterias.push({ property: 'FullFinancialYear', operator: 'eq', comparison: 'FullYearFeesCollected' });
                            // } else if (state.options === BillingByGroupOptionEnum.FEES_RECORDED) {
                            //     searchCriterias.push({ property: 'FullFinancialYear', operator: 'eq', comparison: 'FullYearFeesRecorded' });
                            // } else if (state.options === BillingByGroupOptionEnum.BILLABLE_HOURS) {
                            //     searchCriterias.push({ property: 'FullFinancialYear', operator: 'eq', comparison: 'FullYearBillableHrs' });
                            // } else {
                            //     searchCriterias.push({ property: 'FullFinancialYear', operator: 'eq', comparison: 'FullYearNon-BillableHrs' });
                            // }
                            // props.getSelectedItem(
                            //     searchCriterias,
                            //     true,
                            //     `Full Financial Year`,
                            //     DrillDownType.matterSummaryDrilldown,
                            //     'Next Next Full Financial Year'
                            // );
                        }
                    }}
                    data={{
                        labels: getLabels(state.formats),
                        datasets: [
                            {
                                label: '',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                data: state.valueAmounts,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'x' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick(state.valueAmounts),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(state.valueAmounts),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        // tslint:disable-next-line: max-line-leng
                                        if (state.options === BillingByGroupOptionEnum.BILLABLE_HOURS || state.options === BillingByGroupOptionEnum.NON_BILLABLE_HOURS) {
                                            return `${formatNumber(tickValue)}`;
                                        }
                                        return `${state.symbol} ${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            x: {
                                grid: rvCategoryAxisStyle.grid,
                                // min: 0,
                                // max: 9 // minimum display
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: false,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: false,
                                    },
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   dataIndex,
                                            //   label,
                                            formattedValue,
                                            // dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        let label = 'Fees Billed';
                                        let value = `${state.symbol}${formatNumber(currentValue)}`;
                                        if (state.options === BillingByGroupOptionEnum.FEES_BILLED) {
                                            label = 'Fees Billed';
                                        } else if (state.options === BillingByGroupOptionEnum.FEES_COLLECTED) {
                                            label = 'Fees Collected';
                                        } else if (state.options === BillingByGroupOptionEnum.FEES_RECORDED) {
                                            label = 'Fees Recorded';
                                        } else if (state.options === BillingByGroupOptionEnum.BILLABLE_HOURS) {
                                            label = 'Billable Hours';
                                            value = `${formatNumber(currentValue)}`;
                                        } else {
                                            label = 'Non-Billable Hours';
                                            value = `${formatNumber(currentValue)}`;
                                        }

                                        return [`${label}: ${value}`];

                                    },
                                    // tslint:disable-next-line: no-any no-shadowed-variable
                                    afterLabel: function (context: any) {

                                        const { dataIndex } = context;
                                        const { feesRecorded, feesCollected, feesBilled, billableHours, nonBillableHours } = state.staffBudgets[dataIndex];

                                        if (state.options === BillingByGroupOptionEnum.FEES_BILLED) {
                                            return [
                                                `Fees Recorded: ${state.symbol}${formatNumber(feesRecorded)}`,
                                                `Fees Collected: ${state.symbol}${formatNumber(feesCollected)}`,
                                                `Billable Hours: ${formatNumber(billableHours)}`,
                                                `Non-Billable Hours: ${formatNumber(nonBillableHours)}`,
                                            ];
                                        } else if (state.options === BillingByGroupOptionEnum.FEES_COLLECTED) {
                                            return [
                                                `Fees Recorded: ${state.symbol}${formatNumber(feesRecorded)}`,
                                                `Fees Billed: ${state.symbol}${formatNumber(feesBilled)}`,
                                                `Billable Hours: ${formatNumber(billableHours)}`,
                                                `Non-Billable Hours: ${formatNumber(nonBillableHours)}`,
                                            ];
                                        } else if (state.options === BillingByGroupOptionEnum.FEES_RECORDED) {
                                            return [
                                                `Fees Billed: ${state.symbol}${formatNumber(feesBilled)}`,
                                                `Fees Collected: ${state.symbol}${formatNumber(feesCollected)}`,
                                                `Billable Hours: ${formatNumber(billableHours)}`,
                                                `Non-Billable Hours: ${formatNumber(nonBillableHours)}`,
                                            ];
                                        } else if (state.options === BillingByGroupOptionEnum.BILLABLE_HOURS) {
                                            return [
                                                `Fees Recorded: ${state.symbol}${formatNumber(feesRecorded)}`,
                                                `Fees Billed: ${state.symbol}${formatNumber(feesBilled)}`,
                                                `Fees Collected: ${state.symbol}${formatNumber(feesCollected)}`,
                                                `Non-Billable Hours: ${formatNumber(nonBillableHours)}`,
                                            ];
                                        } else {
                                            return [
                                                `Fees Recorded: ${state.symbol}${formatNumber(feesRecorded)}`,
                                                `Fees Billed: ${state.symbol}${formatNumber(feesBilled)}`,
                                                `Fees Collected: ${state.symbol}${formatNumber(feesCollected)}`,
                                                `Billable Hours: ${formatNumber(billableHours)}`,
                                            ];
                                        }
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.valueAmounts) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <FormControl component="div" className={classes.formControl}>
                <RadioGroup name="options" value={state.options} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel value={BillingByGroupOptionEnum.FEES_BILLED} control={<Radio color="primary" />} label="Fees Billed" />
                    <FormControlLabel value={BillingByGroupOptionEnum.FEES_RECORDED} control={<Radio color="primary" />} label="Fees Recorded" />
                    <FormControlLabel value={BillingByGroupOptionEnum.FEES_COLLECTED} control={<Radio color="primary" />} label="Fees Collected" />
                    <FormControlLabel value={BillingByGroupOptionEnum.BILLABLE_HOURS} control={<Radio color="primary" />} label="Billable Hours" />
                    <FormControlLabel value={BillingByGroupOptionEnum.NON_BILLABLE_HOURS} control={<Radio color="primary" />} label="Non Billable Hours" />
                </RadioGroup>
            </FormControl>
            {/* {state.matterBillingByGroup.length >= 10 && <span className={classes.span}>The top 10 are shown</span>} */}
        </div>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;
export interface BudgetYearData {
    statistics: Statistics;
}

export interface Statistics {
    fees: Fees;
}

export interface Fees {
    yearBudgets: YearBudgets;
}

export interface YearBudgets {
    staffBudgets: StaffBudget[];
    summaries: Summaries;
}

export interface StaffBudget {
    feesRecorded: number;
    feesCollected: number;
    feesBilled: number;
    billableHours: number;
    nonBillableHours: number;
    grouping: Date;
    format: string;
}

export interface Summaries {
    totalFeesRecorded: number;
    totalFeesCollected: number;
    totalFeesBilled: number;
    totalBillableHours: number;
    totalNonBillableHours: number;
}

// export interface MatterBillingData {
//     statistics: Statistics;
// }

// export interface Statistics {
//     lead: Lead;
// }

// export interface Lead {
//     matterBilling: MatterBilling;
// }

// export interface MatterBilling {
//     matterBillingBySource:          MatterBillingBySource;
//     matterBillingByAssignees:       MatterBillingByAssignees;
//     matterBillingByLocation:        MatterBillingByLocation;
//     mtterBillingByAreaOfLaw:        MtterBillingByAreaOfLaw;
//     matterBillingTotalLast3Months:  MatterBillingTotal;
//     matterBillingTotalLast6Months:  MatterBillingTotal;
//     matterBillingTotalLast12Months: MatterBillingTotal;
//     matterBillingTotalAll:          MatterBillingTotal;
// }

// export interface MatterBillingByAssignees {
//     matterBillingByAssigneesLast3Months:  MatterBillingBy;
//     matterBillingByAssigneesLast6Months:  MatterBillingBy;
//     matterBillingByAssigneesLast12Months: MatterBillingBy;
//     matterBillingByAssigneesAll:          MatterBillingBy;
// }

// export interface MatterBillingBy {
//     matterBillingByGroup: MatterBillingByGroup[];
// }

// export interface MatterBillingByGroup {
//     enquiriesCount: number;
//     feesBilled:     number;
//     groupedBy:      string;
// }

// export interface MatterBillingByLocation {
//     matterBillingByLocationLast3Months:  MatterBillingBy;
//     matterBillingByLocationLast6Months:  MatterBillingBy;
//     matterBillingByLocationLast12Months: MatterBillingBy;
//     matterBillingByLocationAll:          MatterBillingBy;
// }

// export interface MatterBillingBySource {
//     matterBillingBySourceLast3Months:  MatterBillingBy;
//     matterBillingBySourceLast6Months:  MatterBillingBy;
//     matterBillingBySourceLast12Months: MatterBillingBy;
//     matterBillingBySourceAll:          MatterBillingBy;
// }

// export interface MatterBillingTotal {
//     totalBilling:      number;
//     enquiriesWonCount: number;
// }

// export interface MtterBillingByAreaOfLaw {
//     matterBillingByAreaOfLawLast3Months:  MatterBillingBy;
//     matterBillingByAreaOfLawLast6Months:  MatterBillingBy;
//     matterBillingByAreaOfLawLast12Months: MatterBillingBy;
//     matterBillingByAreaOfLawAll:          MatterBillingBy;
// }

const BUDGET_YEAR_CHART = gql`
    # Write your query or mutation here
    query YearBudgets($entityType: Int, $entityGuid: String, $responsibility: Int) {
        statistics {
            fees {
                yearBudgets(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
                    staffBudgets {
                        feesRecorded
                        feesCollected
                        feesBilled
                        billableHours
                        nonBillableHours
                        grouping
                        format
                    }
                    summaries {
                        totalFeesRecorded
                        totalFeesCollected
                        totalFeesBilled
                        totalBillableHours
                        totalNonBillableHours
                    }
                }
            }
        }
    }
`;
